import { Component, OnInit, ViewChild, Input, Pipe, Injectable, PipeTransform } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { PrintService } from '../../../../../../../src/app/ncs/services/print.service';

import { AppData } from '../../../../../../../src/app/ncs/models/appdata';
import { ActorService } from '../../../../../../../src/app/ncs/services/actor.service';
import { NgbModal, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { ServiceConfigurationInfoPipe } from '../../../testnurse/service/service.component';
import { HCPService } from '../../../../../../../src/app/ncs/services/hcp.service';
import * as alertFunctions from '../../../../../shared/data/sweet-alerts';

import { ServiceCategoryPipe } from '../../../../../../../src/app/ncs/pipes/actors/actorIdentity.pipes';
import { NGXToastrService } from '../../../../../../../src/app/shared/services/toastr.service';
import { CustomDateTimeService } from '../../../../../../../src/app/ncs/services/datetime.service';
import { SpinnerService } from '../../../../../../../src/app/ncs/services/spinner.service';
import { ApiResponseModel } from '../../../../../../../src/app/ncs/models/api_response_model';
import { FollicularScansBetweenDateController, FollicularScansBetweenDateRequest, FollicularScanDetailController, FollicularScanDetailRequest, IvfCycleMedicineByCodeController, IvfCycleMedicineByCodeRequest, IvfCycleTestByCodeController, IvfCycleTestByCodeRequest, FollicularScanOvaryDetailController, FollicularScanOvaryDetailRequest, SingleWellInseminationByCycleController, SingleWellInseminationByCycleRequest, IvfCycleInseminationLogByCycleWithDOCController, IvfCycleInseminationLogByCycleWithDOCRequest, IvfOocyteEmbryoStorageByCodeController, IvfOocyteEmbryoStorageByCodeRequest, IvfCycleInseminationByCycleController, IvfCycleInseminationByCycleRequest } from '../../../../../../../src/app/ncs/models/actor/actor';




@Component({
    selector: 'inseminationlogdroplet',
    templateUrl: './inseminationlogdroplet.component.html',
    styleUrls: ['./inseminationlogdroplet.component.scss']
})

export class InseminationlogDropletPVComponent implements OnInit {

    public ApiResData: ApiResponseModel;
    public isRequesting: boolean = false;
    public EndometriumThickness: number;
    public LeftOvaries: number;
    public RightOvaries: number;
    public MedicineName: string;
    public TestName: string;
    public TestName1: string;
    public Owner: string;
    public FormattedCode: string;
    public Protocolst: string;
    public ProtocolEd: string;
    public Protocol: string;
    public Infertility: string;
    public Gender: string;
    public Age: string;
    public CycleNo: string;
    public CycleType: string;
    public InsemDate: string;
    public InsemTime: string;
    public NtimesInf: string;
    public ProcessedBy: string;
    public Doctor: string;
    public Details: string;
    public Nurse: string;
    public ActorCode: any;
    public Date: Date;
    minDate: NgbDateStruct;
    maxDate: NgbDateStruct;
    ScanDate: NgbDateStruct;
    SelectedFromDate: NgbDateStruct;
    public Doc: string;
    public DocDate: string;
    public TotalCount: number;
    public ICSICount: number;
    public IMSICount: number;
    public IVFCount: number;
    public EggSourceData: string;
    public DonorData: string;
    public DonorCode: string;



    CurrentIvfCycleInseminationByCycleController: IvfCycleInseminationByCycleController[];
    ICSIList: IvfCycleInseminationByCycleController[];
    IVFList: IvfCycleInseminationByCycleController[];
    IMSIList: IvfCycleInseminationByCycleController[];
    CurrentIvfCycleInseminationByCycleRequest: IvfCycleInseminationByCycleRequest;
    TreatmentCycleCode: any;
    LoadInseminationDatacycle() {
        //alert("ScansData")
        this.CurrentIvfCycleInseminationByCycleRequest = new IvfCycleInseminationByCycleRequest();
        //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
        //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
        //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
        this.TreatmentCycleCode = this.route.snapshot.paramMap.get('TreatmentCycleCodedata');
        this.CurrentIvfCycleInseminationByCycleRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetIvfCycleInseminationByCycleController();
    }

    GetIvfCycleInseminationByCycleController() {
        // this.StartRefreshing();

        this.CurrentIvfCycleInseminationByCycleRequest.CycleCode = this.TreatmentCycleCode;

        //alert(this.FormattedCode);
        this.actorservice.GetIvfCycleInseminationByCycleController(this.CurrentIvfCycleInseminationByCycleRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
                    this.CurrentIvfCycleInseminationByCycleController = this.ApiResData.Result;

                    this.TotalCount = this.CurrentIvfCycleInseminationByCycleController.length;
                    this.ICSIList = this.ApiResData.Result;
                    this.IVFList = this.ApiResData.Result;
                    this.IMSIList = this.ApiResData.Result;
                    var list = this.ICSIList.filter(
                        function (a) {
                            return a.Technique == "ICSI"
                        });
                    this.ICSIList = list;
                    this.ICSICount = this.ICSIList.length;
                    var listIMSI = this.IMSIList.filter(
                        function (b) {
                            return b.Technique == "IMSI"
                        });
                    this.IMSIList = listIMSI;
                    this.IMSICount = this.IMSIList.length;
                    var listIVF = this.IVFList.filter(
                        function (c) {
                            return c.Technique == "IVF"

                        });
                    this.IVFList = listIVF;
                    this.IVFCount = this.IVFList.length;

                    this.stopRefreshing();
                    this.LoadInsemination2();
                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }

    CurrentIvfCycleInseminationLogByCycleWithDOCController: IvfCycleInseminationLogByCycleWithDOCController[];
    //InseminationEndInfo: IvfCycleInseminationLogByCycleWithDOCController;
    CurrentIvfCycleInseminationLogByCycleWithDOCRequest: IvfCycleInseminationLogByCycleWithDOCRequest;
    LoadInsemination2() {
        this.CurrentIvfCycleInseminationLogByCycleWithDOCRequest = new IvfCycleInseminationLogByCycleWithDOCRequest();
        //this.CurrentIvfCycleInseminationLogByCycleWithDOCRequest.TreatmentCycle = this.SelectedpatientDetails.TreatmentCycleCode;
        //this.CurrentIvfCycleInseminationLogByCycleWithDOCRequest.DOC = 1;
        //this.CurrentIvfCycleInseminationLogByCycleWithDOCRequest.ConditionalOperator = 10;
        this.TreatmentCycleCode = this.route.snapshot.paramMap.get('TreatmentCycleCodedata');
        this.CurrentIvfCycleInseminationLogByCycleWithDOCRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetIvfCycleInseminationLogByCycleWithDOCController();
    }
    GetIvfCycleInseminationLogByCycleWithDOCController() {
        this.StartRefreshing();
        this.CurrentIvfCycleInseminationLogByCycleWithDOCRequest.TreatmentCycle = this.TreatmentCycleCode;

        this.actorservice.GetIvfCycleInseminationLogByCycleWithDOCController(this.CurrentIvfCycleInseminationLogByCycleWithDOCRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    this.CurrentIvfCycleInseminationLogByCycleWithDOCController = this.ApiResData.Result;
                    //this.InseminationEndInfo = this.CurrentIvfCycleInseminationLogByCycleWithDOCController[1];
                    //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
                    this.stopRefreshing();
                    this.LoadOqaData();
                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }

    CurrentIvfOocyteEmbryoStorageByCodeController: Array<IvfOocyteEmbryoStorageByCodeController>;
    CurrentIvfOocyteEmbryoStorageByCodeRequest: IvfOocyteEmbryoStorageByCodeRequest;
    OocyteStorageDetails: IvfOocyteEmbryoStorageByCodeController;
    LoadOqaData() {
        //alert("ScansData")
        this.CurrentIvfOocyteEmbryoStorageByCodeRequest = new IvfOocyteEmbryoStorageByCodeRequest();
        //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
        //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
        //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
        this.TreatmentCycleCode = this.route.snapshot.paramMap.get('TreatmentCycleCodedata');
        this.ActorCode = this.route.snapshot.paramMap.get('ActorCodedata');
        this.CurrentIvfOocyteEmbryoStorageByCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetIvfOocyteEmbryoStorageByCodeController();
    }

    GetIvfOocyteEmbryoStorageByCodeController() {
        this.StartRefreshing();

        //this.CurrentIvfOocyteEmbryoStorageByCodeRequest.TreatmentCycle = this.SelectedpatientDetails.TreatmentCycleCode;
        //this.CurrentIvfOocyteEmbryoStorageByCodeRequest.ActorCode = this.SelectedpatientDetails.EggSourceActorCode;
        this.CurrentIvfOocyteEmbryoStorageByCodeRequest.TreatmentCycle = this.TreatmentCycleCode;
        this.CurrentIvfOocyteEmbryoStorageByCodeRequest.ActorCode = this.ActorCode;
        this.CurrentIvfOocyteEmbryoStorageByCodeRequest.ConditionalOperator = 10;

        //alert(this.FormattedCode);
        this.actorservice.GetIvfOocyteEmbryoStorageByCodeController(this.CurrentIvfOocyteEmbryoStorageByCodeRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
                    this.CurrentIvfOocyteEmbryoStorageByCodeController = this.ApiResData.Result;

                    //if (this.CurrentIvfOocyteEmbryoStorageByCodeController != null ||
                    //  this.CurrentIvfOocyteEmbryoStorageByCodeController.length > 0) {

                    //  this.OocyteStoreItems = new Array<OocyteStoreItem>();
                    //  this.CurrentIvfOocyteEmbryoStorageByCodeController.forEach((v, i, d) => {
                    //    var item = new OocyteStoreItem();
                    //    item.IsSelected = false;
                    //    item.Morphology = v.Morphology;
                    //    item.OocyteEmbryoStorageCode = v.OocyteEmbryoStorageCode;
                    //    item.Status = v.Status;
                    //    item.StorageUnitType = v.StorageUnitType;
                    //    item.StorageUnitDetails = v.StorageUnitDetails;
                    //    item.WellNo = v.WellNo;
                    //    this.OocyteStoreItems.push(item);
                    //  });

                    //}

                    //this.OocyteQADetails = this.CurrentOocyteQualityAssessmentByCodeController[0];
                    //this.CurrentOocyteQualityAssessmentByCodeController = new Array<OocyteQualityAssessmentByCodeController>();
                    //var data = this.ApiResData.Result as Array<OocyteQualityAssessmentByCodeController>;

                    //data.forEach((v, i, a) => {
                    //    this.CurrentOocyteQualityAssessmentByCodeController.push(v);
                    //});
                    //for (let index = 0; index < data.length; index++){
                    //    //alert(data[index].SingleWellFollicleCoder);

                    //    this.CurrentOocyteQualityAssessmentByCodeController.push(data[index]);
                    //}
                    //    this.FollicularOocyteInfo = this.CurrentOocyteQualityAssessmentByCodeController[0];
                    //   alert(this.FollicularOocyteInfo.TreatmentCycle);
                    //if (this.FollicularScanEndInfo.ScanDate != null) {
                    //  var SValidFrom = new Date(this.FollicularScanEndInfo.ScanDate);
                    //  if (SValidFrom.getFullYear() > 1900) {
                    //    console.log('this.UpdateDate >1990');
                    //    this.ScanDate = {

                    //      year: SValidFrom.getFullYear(),
                    //      month: SValidFrom.getMonth() + 1,
                    //      day: SValidFrom.getDate()
                    //    }
                    //  }
                    //}
                    //this.CurrentSaveFollicularScanDetailRequest.EndometriumThickness
                    //  = this.FollicularScanEndInfo.EndometriumThickness;
                    //this.CurrentSaveFollicularScanDetailRequest.Remarks = this.FollicularScanEndInfo.Comments;
                    //this.CurrentSaveFollicularScanDetailRequest.ScanDate = this.FollicularScanEndInfo.ScanDate;

                    //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

                    this.stopRefreshing();
                    this.printService.onDataReady();
                    //   this.LoadGuardian();
                    //this.LoadMessages();


                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }

    constructor(private router: Router,
        private actorservice: ActorService,
        private route: ActivatedRoute, private hcpservice: HCPService, private loaderService: SpinnerService,
        private modalService: NgbModal, private filter: ServiceConfigurationInfoPipe, private filter2: ServiceCategoryPipe, private customdatetimeservice: CustomDateTimeService,
        private parserFormatter: NgbDateParserFormatter, private tosterservice: NGXToastrService,

        public printService: PrintService) {


    }


    ngOnInit() {
        //alert("in scans comp");
        this.Date = new Date();

        this.Doc = this.route.snapshot.paramMap.get('Doc');
        this.DocDate = this.route.snapshot.paramMap.get('DocDate');
        this.Owner = this.route.snapshot.paramMap.get('Owner');
        this.FormattedCode = this.route.snapshot.paramMap.get('PatientId');
        this.Protocolst = this.route.snapshot.paramMap.get('ProtocolStart');
        this.ProtocolEd = this.route.snapshot.paramMap.get('ProtocolEnd');
        this.Protocol = this.route.snapshot.paramMap.get('Protocol');
        this.Infertility = this.route.snapshot.paramMap.get('Infertility');
        this.Gender = this.route.snapshot.paramMap.get('Gender');
        this.Age = this.route.snapshot.paramMap.get('Age');
        this.CycleNo = this.route.snapshot.paramMap.get('CycleNo');
        this.CycleType = this.route.snapshot.paramMap.get('CycleType');
        this.InsemDate = this.route.snapshot.paramMap.get('InsemDate');
        this.InsemTime = this.route.snapshot.paramMap.get('InsemTime');
        this.NtimesInf = this.route.snapshot.paramMap.get('NtimesInf');
        this.ProcessedBy = this.route.snapshot.paramMap.get('ProcessedBy');
        this.Doctor = this.route.snapshot.paramMap.get('Doctor');
        this.Details = this.route.snapshot.paramMap.get('Details');
        this.Nurse = this.route.snapshot.paramMap.get('Nurse');
        this.EggSourceData = this.route.snapshot.paramMap.get('EggSourceData');
        this.DonorData = this.route.snapshot.paramMap.get('DonorData');
        this.DonorCode = this.route.snapshot.paramMap.get('DonorCode');

        this.LoadInseminationDatacycle();


    }


    private stopRefreshing() {
        this.loaderService.displayLoader(false);
        this.isRequesting = false;
    }
    private StartRefreshing() {
        this.loaderService.displayLoader(true);
        this.isRequesting = true;
    }

}








